import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IAppConfig } from '@interfaces/app-config.interface';

import appInfo from '../../app-info';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private _appConfig: BehaviorSubject<IAppConfig> = new BehaviorSubject<IAppConfig>(null);

  constructor(private http: HttpClient) {}

  public get config(): IAppConfig {
    return this._appConfig.getValue();
  }

  public get config$(): Observable<IAppConfig> {
    return this._appConfig.asObservable();
  }

  public loadConfig(): Promise<IAppConfig> {
    return this.http
      .get<IAppConfig>(`/assets/config/config.json?key=${appInfo.buildHash}`)
      .toPromise()
      .then((config: IAppConfig) => {
        this._appConfig.next(config);
        return config;
      });
  }
}
